export const KOUNT_DEVICE_DATA_URLS = {
  config: 'https://tst.kaptcha.com/cs/config',
  cookie: 'https://tst.kaptcha.com/cs/generatecookie',
  sessionId: 'https://tst.kaptcha.com/session/:session_id',
};
